import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

function ScrollRestoration() {
  const { pathname } = useLocation();

  useEffect(() => {
    // Restore scroll position if we have it saved
    const savedPosition = window.history.state?.scrollY;
    if (savedPosition) {
      window.scrollTo(0, savedPosition);
    } else {
      // Scroll to top for new page visits
      window.scrollTo(0, 0);
    }

    // Save scroll position before unmounting
    const handleScroll = () => {
      const state = window.history.state || {};
      window.history.replaceState(
        {
          ...state,
          scrollY: window.scrollY,
        },
        ''
      );
    };

    // Throttle scroll event
    let timeoutId = null;
    const throttledScroll = () => {
      if (timeoutId) {
        clearTimeout(timeoutId);
      }
      timeoutId = setTimeout(handleScroll, 100);
    };

    window.addEventListener('scroll', throttledScroll);
    return () => window.removeEventListener('scroll', throttledScroll);
  }, [pathname]);

  return null;
}

export default ScrollRestoration;